(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linqton-customization-portal"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelector('.cf-turnstile') && !document.querySelector('script[data-linqton-turnstile]')) {
    const turnstileScript = document.createElement('script');
    turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    turnstileScript.async = true;
    turnstileScript.defer = true;
    turnstileScript.dataset.linqtonTurnstile = 'true';
    document.head.append(turnstileScript);
  }

  const portals = document.querySelectorAll('[data-customization-portal]');

  portals.forEach((portal) => {
    if (portal.dataset.initialized === 'true') return;
    portal.dataset.initialized = 'true';

    const orderForm = portal.querySelector('[data-order-form]');
    const uploadForm = portal.querySelector('[data-upload-form]');
    const status = portal.querySelector('[data-status]');
    const lineItems = portal.querySelector('[data-line-items]');
    const notificationForm = portal.querySelector('#LinQtonCustomizationNotification');
    let sessionToken = '';
    let verifiedOrder = '';
    let verifiedEmail = '';

    const setStatus = (message, isError = false) => {
      status.textContent = message;
      status.dataset.error = isError ? 'true' : 'false';
    };

    const setBusy = (form, busy) => {
      const button = form.querySelector('button[type="submit"]');
      button.disabled = busy;
    };

    orderForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!orderForm.reportValidity()) return;
      setBusy(orderForm, true);
      setStatus(portal.dataset.statusVerifying);

      const formData = new FormData(orderForm);
      const turnstileInput = orderForm.querySelector('[name="cf-turnstile-response"]');
      const requestBody = {
        orderNumber: formData.get('orderNumber'),
        email: formData.get('email'),
        turnstileToken: turnstileInput ? turnstileInput.value : '',
      };

      try {
        const response = await fetch(portal.dataset.verifyUrl, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(requestBody),
        });
        const result = await response.json();
        if (!response.ok || !result.ok) throw new Error(result.error || 'verification_failed');

        sessionToken = result.sessionToken;
        verifiedOrder = result.order.name;
        verifiedEmail = String(requestBody.email);
        lineItems.replaceChildren();
        result.lineItems.forEach((item) => {
          const option = document.createElement('option');
          option.value = item.id;
          option.textContent = `${item.productTitle}${item.variantTitle ? ` · ${item.variantTitle}` : ''}`;
          lineItems.append(option);
        });
        portal.querySelector('[data-verified-order]').textContent = `${verifiedOrder} · ${result.lineItems.length} customizable item(s) verified`;
        uploadForm.hidden = false;
        orderForm.hidden = true;
        setStatus('');
      } catch (error) {
        setStatus(`${portal.dataset.errorOrder} (${error.message})`, true);
        if (window.turnstile) window.turnstile.reset();
      } finally {
        setBusy(orderForm, false);
      }
    });

    uploadForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!uploadForm.reportValidity()) return;
      const selectedFiles = uploadForm.elements.files.files;
      if (!selectedFiles.length || selectedFiles.length > 5 || [...selectedFiles].some((file) => file.size > 10 * 1024 * 1024)) {
        setStatus(portal.dataset.errorFiles, true);
        return;
      }

      setBusy(uploadForm, true);
      setStatus(portal.dataset.statusUploading);
      const formData = new FormData();
      formData.append('lineItemId', uploadForm.elements.lineItemId.value);
      formData.append('instructions', uploadForm.elements.instructions.value);
      [...selectedFiles].forEach((file) => formData.append('files', file));

      try {
        const response = await fetch(portal.dataset.uploadUrl, {
          method: 'POST',
          headers: { authorization: `Bearer ${sessionToken}` },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || !result.ok) throw new Error(result.error || 'upload_failed');

        const selectedItem = lineItems.options[lineItems.selectedIndex].textContent;
        const fileLines = result.files.map((file) => `${file.name}: ${file.url}`).join('\n');
        notificationForm.querySelector('[data-notification-email]').value = verifiedEmail;
        notificationForm.querySelector('[data-notification-order]').value = verifiedOrder;
        notificationForm.querySelector('[data-notification-item]').value = selectedItem;
        notificationForm.querySelector('[data-notification-body]').value = `Verified customization upload\nOrder: ${verifiedOrder}\nItem: ${selectedItem}\nInstructions: ${uploadForm.elements.instructions.value || 'None'}\nFiles:\n${fileLines}`;
        setStatus('Upload complete. Sending the order details to LinQton…');
        notificationForm.requestSubmit(notificationForm.querySelector('[data-notification-submit]'));
      } catch (error) {
        setStatus(`${portal.dataset.errorUpload} (${error.message})`, true);
        setBusy(uploadForm, false);
      }
    });

    const inquiryForm = portal.querySelector('#LinQtonCustomizationInquiry');
    inquiryForm?.addEventListener('submit', (event) => {
      const email = inquiryForm.querySelector('[data-inquiry-email]').value.trim();
      const phone = inquiryForm.querySelector('[data-inquiry-phone]').value.trim();
      if (!email && !phone) {
        event.preventDefault();
        inquiryForm.querySelector('[data-inquiry-email]').setCustomValidity('Please enter an email address or phone number.');
        inquiryForm.querySelector('[data-inquiry-email]').reportValidity();
      } else {
        inquiryForm.querySelector('[data-inquiry-email]').setCustomValidity('');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
